import './BarraNavInferior.css';

const iconInicio = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23679509' stroke-width='2.2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M3 10.5 12 3l9 7.5'/%3E%3Cpath d='M5 9.5V21h14V9.5'/%3E%3Cpath d='M9.5 21v-6h5v6'/%3E%3C/svg%3E";
const iconTickets = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2' stroke-linecap='round'%3E%3Cpath d='M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z'/%3E%3Cpath d='M13 5v2m0 4v2m0 4v2'/%3E%3C/svg%3E";
const iconFavoritos = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2'%3E%3Cpath d='M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z'/%3E%3C/svg%3E";
const iconPerfil = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2' stroke-linecap='round'%3E%3Cpath d='M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2'/%3E%3Ccircle cx='12' cy='7' r='4'/%3E%3C/svg%3E";

export default function BarraNavInferior() {
  const dispatch = (evtName, e) => {
    e.preventDefault();
    window.dispatchEvent(new CustomEvent(evtName));
  };

  return (
    <nav className="barra-nav-inferior">
      <a href="/" className="barra-nav-inferior__item barra-nav-inferior__item--activo">
        <img src={iconInicio} alt="" className="barra-nav-inferior__icono" />
        <span className="barra-nav-inferior__texto">Inicio</span>
      </a>
      <a href="/mi-cuenta" className="barra-nav-inferior__item">
        <img src={iconTickets} alt="" className="barra-nav-inferior__icono" />
        <span className="barra-nav-inferior__texto">Cupones</span>
      </a>
      <a href="#" className="barra-nav-inferior__item" onClick={(e) => dispatch('open-favorites', e)}>
        <img src={iconFavoritos} alt="" className="barra-nav-inferior__icono" />
        <span className="barra-nav-inferior__texto">Favoritos</span>
      </a>
      <a href="#" className="barra-nav-inferior__item" onClick={(e) => dispatch('open-profile', e)}>
        <img src={iconPerfil} alt="" className="barra-nav-inferior__icono" />
        <span className="barra-nav-inferior__texto">Perfil</span>
      </a>
    </nav>
  );
}
